import React from 'react';
import Input from '../../../Components/Input';
import DimensionSelector from '../DimensionSelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import MediaSelector from '../MediaSelector';
import VendexElement, { VendexRadioMeta } from '../../../Model/VendexElement';
import Select from '../../../Components/Select';
import { BuilderField, BuilderFieldGrid } from '../BuilderFields';

type Props = {
    element: VendexElement;
};

function RadioDetail({ element }: Props) {
    const data = element.metaData as VendexRadioMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string | boolean) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    return (
        <>
            <BuilderFieldGrid>
                <BuilderField
                    label="Name"
                    helperText="Assign the same name to related radio buttons to allow single selection."
                >
                    <Input
                        onChange={(e) => {
                            handleDataChange('name', e.target.value);
                        }}
                        value={data.name}
                    />
                </BuilderField>
                <BuilderField label="Value">
                    <Input
                        onChange={(e) => {
                            handleDataChange('value', e.target.value);
                        }}
                        value={data.value}
                    />
                </BuilderField>
                <BuilderField label="Default checked">
                    <Select
                        value={data.defaultCheck ? 'Yes' : 'No'}
                        onChange={(e) =>
                            handleDataChange(
                                'defaultCheck',
                                e.target.value === 'Yes',
                            )
                        }
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </Select>
                </BuilderField>
                <BuilderField label="Checked image">
                    <MediaSelector
                        url={data.checkedImage}
                        onChange={(value) =>
                            handleDataChange('checkedImage', value)
                        }
                        type="IMAGE"
                    />
                </BuilderField>
                <BuilderField label="Unchecked image">
                    <MediaSelector
                        url={data.uncheckedImage}
                        onChange={(value) =>
                            handleDataChange('uncheckedImage', value)
                        }
                        type="IMAGE"
                    />
                </BuilderField>
            </BuilderFieldGrid>
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
        </>
    );
}

export default RadioDetail;
